import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";

export default function SubsectionForm({
  subsection = null,
  onSave,
  onCancel,
  loading = false,
  error = null
}) {
  const [name, setName] = useState(subsection?.name || "");
  const [validationError, setValidationError] = useState("");

  const isEditing = Boolean(subsection);

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidationError("");

    if (!name.trim()) {
      setValidationError("Subsection name is required");
      return;
    }

    onSave({ name: name.trim() });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        p: 2,
        mb: 2,
        border: 1,
        borderColor: "grey.300",
        borderRadius: 1,
        backgroundColor: "grey.50"
      }}
    >
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {isEditing ? "Edit Subsection" : "Add Subsection"}
      </Typography>

      <TextField
        label="Subsection Name"
        fullWidth
        size="small"
        value={name}
        onChange={(e) => setName(e.target.value)}
        disabled={loading}
        error={!!validationError || !!error}
        helperText={validationError || error?.message}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          type="submit"
          variant="contained"
          size="small"
          disabled={loading}
        >
          {loading ? "Saving..." : isEditing ? "Save" : "Save Subsection"}
        </Button>
        <Button
          type="button"
          variant="outlined"
          size="small"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
